import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CollectionsListTabComponent } from './tabs/collections-list-tab/collections-list-tab.component';
import { CollectionsPeriodsTabComponent } from './tabs/collections-periods-tab/collections-periods-tab.component';
import { CollectionsBoostersTabComponent } from './tabs/collections-boosters-tab/collections-boosters-tab.component';

@Component({
  templateUrl: 'collections.component.html',
  standalone: true,
  imports: [CommonModule, TabsModule, CollectionsListTabComponent, CollectionsPeriodsTabComponent, CollectionsBoostersTabComponent]
})
export class CollectionsComponent {

  @ViewChild('collectionsTab') collectionsTab!: CollectionsListTabComponent;
  @ViewChild('periodsTab') periodsTab!: CollectionsPeriodsTabComponent;
  @ViewChild('boostersTab') boostersTab!: CollectionsBoostersTabComponent;

  onSelectCollectionsTab(): void { this.collectionsTab.refresh(); }
  onSelectPeriodsTab(): void { this.periodsTab.refresh(); }
  onSelectBoostersTab(): void { this.boostersTab.refresh(); }
}
